import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IAppointment, defaultValue } from 'app/shared/model/appointment.model';

export const ACTION_TYPES = {
  FETCH_APPOINTMENT_LIST: 'ps-appointment/FETCH_APPOINTMENT_LIST',
  RESET: 'ps-appointment/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IAppointment>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type PatientAppointmentState = Readonly<typeof initialState>;

// Reducer

export default (state: PatientAppointmentState = initialState, action): PatientAppointmentState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_APPOINTMENT_LIST):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_APPOINTMENT_LIST):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_APPOINTMENT_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = process.env.REACT_APP_API_URL + '/appointments';

// Actions

// export const getEntities: ICrudGetAllAction<IAppointment> = (page, size, sort) => {
//   const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
//   return {
//     type: ACTION_TYPES.FETCH_APPOINTMENT_LIST,
//     payload: axios.get<IAppointment>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
//   };
// };

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});

export const getAppointmentsByUserId = (fromDate, toDate, userId) => {
  let requestUrl = `${process.env.REACT_APP_API_URL}/appointments/patient/bydateandId?`;
  if (fromDate) {
    requestUrl += `&fromDate=${fromDate}`;
  }
  if (toDate) {
    requestUrl += `&toDate=${toDate}`;
  }

  if (userId) {
    requestUrl += `&userId=${userId}`;
  }

  return {
    type: ACTION_TYPES.FETCH_APPOINTMENT_LIST,
    payload: axios.get(requestUrl),
  };
};
